import React, { useState } from 'react';
import {DropDownNavBarMenu} from "./drop-down-navbar-menu";
import AppBar from '@mui/material/AppBar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import Toolbar from '@mui/material/Toolbar';
import {Link, useHistory} from "react-router-dom";
import {Box, InputAdornment, TextField} from "@mui/material";
import Hidden from "@mui/material/Hidden";
import {AuthService} from "../../../screens/auth/service/auth-service";
import FolderIcon from '@mui/icons-material/Folder';
import SearchIcon from '@mui/icons-material/Search';

const navButtonSx = {
  color: 'text.secondary', fontWeight: 500, fontSize: '0.875rem',
  px: 2, py: 1, borderRadius: '8px', transition: 'all 0.2s ease',
  '&:hover': { background: 'rgba(99, 102, 241, 0.06)', color: 'primary.main', transform: 'none' },
};

export function MyTopAppBar(props) {
    const { loggedIn, loggedInUser } = props;
    const history = useHistory();
    const [query, setQuery] = useState('');
    const logout = async () => { await AuthService.signOut(); history.push("/login"); };

    const handleSearch = (e) => {
        e.preventDefault();
        if (query.trim()) {
            history.push('/search?q=' + encodeURIComponent(query.trim()));
        }
    };

    return (
        <Box flexDirection="row" width={1}>
            <CssBaseline/>
            <AppBar position="fixed" color="default" elevation={0}>
                <Toolbar sx={{ minHeight: '64px !important' }}>
                    <Box sx={{ flexGrow: 0, display: 'flex', alignItems: 'center', mr: 2 }}>
                        <Link to="/projects">
                            <img src={window.location.origin + '/logos/logo-md.png'}
                                 style={{width: "160px", display: 'block'}} alt="AssetsMaven"/>
                        </Link>
                    </Box>
                    <Hidden smDown>
                        {loggedIn && (
                            <>
                                <Box sx={{ display: 'flex', gap: 0.5, mr: 2 }}>
                                    <Button component={Link} to="/projects" startIcon={<FolderIcon sx={{ fontSize: '1.1rem', color: 'inherit' }} />} sx={navButtonSx}>
                                        Projects
                                    </Button>
                                </Box>
                                <Box component="form" onSubmit={handleSearch} sx={{ flex: 1, maxWidth: 400 }}>
                                    <TextField size="small" fullWidth placeholder="Search statements & receipts..."
                                        value={query} onChange={e => setQuery(e.target.value)}
                                        InputProps={{
                                            startAdornment: <InputAdornment position="start"><SearchIcon sx={{ fontSize: '1.1rem', color: 'text.secondary' }} /></InputAdornment>,
                                        }}
                                        sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2, fontSize: '0.85rem', background: 'rgba(0,0,0,0.02)' } }}
                                    />
                                </Box>
                            </>
                        )}
                    </Hidden>
                    <Box sx={{ flex: 1 }} />
                    {loggedIn && <DropDownNavBarMenu loggedIn={loggedIn} logoutFunction={logout} loggedInUser={loggedInUser}/>}
                    {!loggedIn && (
                        <Button component={Link} to="/login" variant="contained" size="small" sx={{ borderRadius: '8px' }}>Login</Button>
                    )}
                </Toolbar>
            </AppBar>
            <Toolbar />
        </Box>
    );
}

export default MyTopAppBar;
